import { privateAxios } from "../axiosInstances";

export const getEventFormAnswersAsExcel = async (eventId: string) => {
  const { data } = await privateAxios.get<Blob>(
    `/event-form-answers/${eventId}/export`,
    { responseType: "blob" }
  );
  return data;
};